export const SkillCategoryConstants = {
  PRODUCTIVITY_SOFTWARE: "Productivity Software",
  PROGRAMMING_LANGUAGES: "Programming Languages",
  BASEBALL_CENTRIC_KNOWLEDGE: "Baseball Centric Knowledge",
  BASEBALL_BUSINESS_SKILL: "Baseball Business Skill"
};
